module.exports = __webpack_public_path__ + "img/request-to-join/invite-cl-teammates-a2ff3e2810a4e2457c5ccd6db9ec60f4.png";